



















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "AgendaGlobalToolbar" })
export default class AgendaGlobalToolbar extends Vue {
  @Prop({ default: null }) public idCentro!: number | null;
  @Prop({ default: () => [] }) public centrosItems!: any[];
  @Prop({ default: false }) public centroFijado!: boolean;
  @Prop({ default: "" }) public calendarTitle!: string;
  @Prop({ default: "timeGridWeek" }) public currentView!: string;
  @Prop({ default: false }) public loading!: boolean;
}
